<div class="row-flex page-references" *ngIf="ref2 | async as item">
    <div class="container col-flex-lg-12 col-flex-md-12 col-flex-sm-12 col-flex-xs-12 px-sm-20">
        <p class="reference1">{{item.headline}}</p>
        <p class="reference" *ngIf="item.largeparagraphcontent" [innerHTML]="item.largeparagraphcontent"></p>
    </div>

    <!-- <div class="container col-flex-lg-12 col-flex-md-12 col-flex-sm-12 col-flex-xs-12 px-sm-20 largeparagraphcontent">
        <p class="reference" *ngIf="item.largeparagraphcontent" [innerHTML]="item.largeparagraphcontent"></p>
    </div> -->
</div>